import { createContext, useContext } from "react"

export type GraphIntervalType = "year" | "month" | "all"

export const AvailableDatePeriods = {
	MONTH: "month",
	YEAR: "year",
	ALL: "all",
}

type ProductionCumulativeContextType = {
	graphInterval: GraphIntervalType
	setGraphInterval(
		graphInterval: ProductionCumulativeContextType["graphInterval"],
	): void
	startTime: any
	setStartTime(startTime: any): void
	endTime: any
	setEndTime(endTime: any): void
	minimumTime: any
	setMinimumTime(minimumTime: any): void
}

export const ProductionCumulativeContext =
	createContext<ProductionCumulativeContextType>(null!)

export function useProductionCumulativeGraphContext() {
	const context = useContext(ProductionCumulativeContext)

	if (!context) {
		throw new Error(
			"ProductionCumulativeContext must be used within a ProductionCumulativeContextProvider",
		)
	}

	return context
}
